import {Component, OnInit} from '@angular/core';
import {GoogleAnalyticsService} from './services/googleAnalytics/google-analytics.service';
import {ConfigService} from './services/config/config.service';
import {MapService} from './services/map/map.service';
import {NotificationService} from './services/notification/notification.service';
import {InitializeService} from './services/initialize/initialize-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(private ga: GoogleAnalyticsService, private config: ConfigService,
              private map: MapService, private notification: NotificationService,
              private init: InitializeService) {}

  ngOnInit() {
    this.map.setupMap(this.map.getmapLoadedObservable(), {basemap: this.config.mapInitialLayer, 
    zoom:this.config.mapInitialZoomLevel, center:this.config.mapInitialCenter});
    //console.log('***call setupmap zoom: ' + this.config.mapInitialZoomLevel +  'center: ' + this.config.mapInitialCenter);
    this.ga.init();
    this.notification.init();
    this.init.init(true);
  }
}
